import { render } from "./StageSlot.vue?vue&type=template&id=21981417&scoped=true"
import script from "./StageSlot.vue?vue&type=script&lang=js"
export * from "./StageSlot.vue?vue&type=script&lang=js"

import "./StageSlot.vue?vue&type=style&index=0&id=21981417&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21981417"]])

export default __exports__